module.exports = __webpack_public_path__ + "static/media/arrow-left-active.10b91b35.svg";